import React, { Component } from 'react';
import {
  FormGroup,
  Input,
  Button,
  Card,
  CardBody,
  CardTitle,
} from 'reactstrap';
import { actions, Control, Errors } from 'react-redux-form/immutable';
import PropTypes from 'prop-types';
import { Map, fromJS } from 'immutable';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classnames from 'classnames';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { AddIcon } from '../icon/AddIcon';
import { RemoveIcon } from '../table/RemoveIcon';
import { fieldToNumber, fieldTrimmed } from './formUtilities';
import { SingleResultGrid } from '../grid/SingleResultGrid';
import { Column } from '../grid/Column';
import { Loading } from '../loadbar/Loading';
import { ResultGrid } from '../grid/ResultGrid';
import {
  tsuVisibleColumns,
  tsuSort,
  minColumns,
} from '../../redux/EditReduxConstant';

const resolvePublish = ({ value }) => {
  if (value == null) {
    return null;
  }
  return value ? 'Y' : 'N';
};

const defaultMap = fromJS({});

class AssociatedTsunamiControlUnwrapped extends Component {
  constructor(props) {
    super(props);
    this.searchTsunamis = this.searchTsunamis.bind(this);
    this.addTsunami = this.addTsunami.bind(this);
    this.handleToggleColumns = this.handleToggleColumns.bind(this);
    this.resolveRemove = this.resolveRemove.bind(this);
    this.toggleSearch = this.toggleSearch.bind(this);
    this.renderAddButton = this.renderAddButton.bind(this);
    this.state = {
      tsunamis: Map(),
      searchVisible: false,
      searchInput: '',
    };
  }

  componentDidMount() {
    const { tsunami } = this.props;
    this.setState((state) => {
      const tsunamiId = tsunami.get('id');
      const tsunamis = tsunamiId ? state.tsunamis.set(`${tsunamiId}`, tsunami) : state.tsunamis;
      return {
        tsunamis,
      };
    });
  }

  searchTsunamis() {
    const { searchTsunamis } = this.props;
    const { searchInput } = this.state;
    searchTsunamis({
      queryParameters: {
        op: 'or',
        locInclude: fieldTrimmed(searchInput),
        id: fieldToNumber(searchInput),
        country: fieldTrimmed(searchInput),
        year: fieldToNumber(searchInput),
      },
    });
  }

  addTsunami(tsu) {
    const { tsunami, change, model } = this.props;
    const id = tsu ? tsu.get('id') : '';
    this.setState((state) => {
      const tsunamis = state.tsunamis.filter(existing => existing.get('id') === tsunami.get('id'));
      return {
        tsunamis: tsu ? tsunamis.set(`${id}`, tsu) : tsunamis,
      };
    }, () => {
      change(`${model}.tsunamiEventId`, `${id}`);
    });
  }

  resolveRemove({ row }) {
    if (row.get('id') == null) {
      return null;
    }
    return (<RemoveIcon handleClick={() => this.addTsunami()} />);
  }

  handleToggleColumns({ visibleColumns, sort }) {
    const {
      visibleColumns: preVisibleColumns, sort: prevSort, sortData, toggleColumns,
    } = this.props;
    let changed = false;
    if (!visibleColumns.sort().equals(preVisibleColumns.sort())) {
      toggleColumns(visibleColumns);
      changed = true;
    }
    if (!sort.equals(prevSort)) {
      sortData(sort);
      changed = true;
    }
    return changed;
  }

  toggleSearch() {
    this.setState(({ searchVisible: prev }) => ({ searchVisible: !prev }));
  }

  renderAddButton({ row }) {
    const { tsunamiId } = this.props;
    if (`${row.get('id')}` !== tsunamiId) {
      return (<AddIcon handleClick={() => this.addTsunami(row)} />);
    }
    return (<div />);
  }

  render() {
    const {
      tsunamiSearching, tsunamiSearchResults, tsunamiId, sort, valid, visibleColumns,
    } = this.props;
    const { tsunamis, searchVisible } = this.state;
    return (
      <Card>
        <CardBody>
          <CardTitle tag="h2">Associated Tsunami</CardTitle>
          <SingleResultGrid data={tsunamis.get(tsunamiId) ? tsunamis.get(tsunamiId) : defaultMap}>
            <Column id="remove" cell={this.resolveRemove} width={50}><RemoveIcon /></Column>
            <Column id="id" width={100}>ID</Column>
            <Column id="publish" cell={resolvePublish} width={85}>Publish</Column>
            <Column id="year" width={75} helpModalId="year">Year</Column>
            <Column id="month" width={50} helpModalId="month">Mo</Column>
            <Column id="day" width={50} helpModalId="day">Dy</Column>
            <Column id="country" width={150}>Country</Column>
            <Column id="locationName" width={150} helpModalId="tsuLocationName">Location Name</Column>
          </SingleResultGrid>
          <Control
            type="hidden"
            model=".tsunamiEventId"
            mapProps={{
              tabIndex: '-1',
              className: ({ fieldValue }) => classnames({ 'form-control': true, 'sr-only': true, 'is-invalid': !fieldValue.valid }),
            }}
          />
          <Errors
            model=".tsunamiEventId"
            component="div"
            wrapper={({ children }) => <div className={classnames({ 'invalid-feedback': true, 'haz-associated-table-error': !valid })}>{children}</div>}
          />

          {searchVisible ? (
            <Card>
              <CardBody>
                <CardTitle tag="h2" className="haz-close-title">
                  <span>Search</span>
                  <button type="button" className="close" aria-label="Close" onClick={this.toggleSearch}>x</button>
                </CardTitle>
                <div className="haz-assoc-search-container">
                  <div className="form-inline">
                    <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                      <Input disabled={tsunamiSearching} onChange={(e) => { this.setState({ searchInput: e.target.value }); }} type="text" />
                    </FormGroup>
                    <Button disabled={tsunamiSearching} onClick={this.searchTsunamis}>Search</Button>
                  </div>

                  <div className="haz-assoc-search">
                    {tsunamiSearching ? (<Loading />) : (
                      <ResultGrid
                        data={tsunamiSearchResults}
                        sort={sort}
                        handleColumnsToggle={this.handleToggleColumns}
                        columnChooser
                        visibleColumns={visibleColumns}
                        defaultColumns={tsuVisibleColumns}
                        defaultSort={tsuSort}
                        minColumns={minColumns}
                      >
                        <Column id="add" width={50} alwaysVisible cell={this.renderAddButton}><AddIcon /></Column>
                        <Column id="id" width={100} sortable>ID</Column>
                        <Column id="publish" cell={resolvePublish} width={120} sortable>Publish</Column>
                        <Column id="year" width={100} sortable helpModalId="year">Year</Column>
                        <Column id="month" width={100} sortable helpModalId="month">Mo</Column>
                        <Column id="day" width={100} sortable helpModalId="day">Dy</Column>
                        <Column id="country" width={150} sortable>Country</Column>
                        <Column id="locationName" width={150} sortable helpModalId="tsuLocationName">Location Name</Column>
                      </ResultGrid>
                    )}
                  </div>
                </div>
              </CardBody>
            </Card>
          ) : (<Button onClick={this.toggleSearch}>Search</Button>)}

        </CardBody>
      </Card>
    );
  }
}


AssociatedTsunamiControlUnwrapped.propTypes = {
  model: PropTypes.string.isRequired,
  tsunami: ImmutablePropTypes.map.isRequired,
  searchTsunamis: PropTypes.func.isRequired,
  tsunamiSearching: PropTypes.bool.isRequired,
  tsunamiSearchResults: ImmutablePropTypes.list.isRequired,
  change: PropTypes.func.isRequired,
  tsunamiId: PropTypes.string.isRequired,
  sort: ImmutablePropTypes.list.isRequired,
  valid: PropTypes.bool.isRequired,
  visibleColumns: ImmutablePropTypes.list.isRequired,
  toggleColumns: PropTypes.func.isRequired,
  sortData: PropTypes.func.isRequired,
};


const mapStateToProps = (state, { model }) => ({
  tsunamiId: state.getIn([model, 'tsunamiEventId']) ? state.getIn([model, 'tsunamiEventId']) : '',
  valid: state.get('forms')[model].tsunamiEventId.valid,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  change: actions.change,

}, dispatch);

export const AssociatedTsunamiControl = connect(mapStateToProps, mapDispatchToProps)(AssociatedTsunamiControlUnwrapped);
